import { Record } from "immutable";
import moment from "moment";

const defaults = {
    carrierRegistrationFieldId: undefined,
    createdOn: undefined,
    displayName: undefined,
    id: undefined,
    isEditable: undefined,
    isEncrypted: undefined,
    modifiedOn: undefined,
    name: undefined,
    prerequisiteField: undefined,
    required: undefined,
    type: undefined,
    validValues: undefined,
    value: undefined,
};

export class AccountCarrierField extends Record(defaults) {
    declare carrierRegistrationFieldId: string;
    declare createdOn: moment.Moment;
    declare displayName: string;
    declare id: string;
    declare isEditable: boolean;
    declare isEncrypted: boolean;
    declare modifiedOn: moment.Moment;
    declare name: string;
    declare prerequisiteField: string | null;
    declare required: boolean;
    declare type: string;
    declare validValues: any[] | null;
    declare value: any;

    constructor(args) {
        super({
            ...args,
            carrierRegistrationFieldId: args.carrier_registration_field_id,
            displayName: args.display_name,
            isEditable: args.is_editable,
            isEncrypted: args.is_encrypted,
            prerequisiteField: args.prerequisite_field,
            required: args.is_required,
            validValues: args.valid_values ? args.valid_values : [],
        });
    }
}
